<template>
    <v-form ref="formSelect">
      <v-select
          v-model="item"
          :items="items"
          :label="itemAction.name"
          @click:clear="onClearData()"
          clearable
          outlined
          dense>
          <template #selection="{ item }">
            <v-list-item-action-text dense>
              <span class="font-weight-bold sub subtitle-1">{{ item }}</span>
            </v-list-item-action-text>
          </template>
          <template #item="{ item }">
            <v-list-item-action-text dense>
              <span class="font-weight-bold subtitle-2">{{ item }}</span>
            </v-list-item-action-text>
          </template>
      </v-select>
    </v-form>
    </template>
<script>
import { DatesUtils } from '@/mixins/datesUtilsMixin'
export default {
  mixins: [DatesUtils],
  props: ['itemAction', 'setterModel', 'onSuccess'],
  data: () => ({
    item: '',
    items: []
  }),
  watch: {
    setterModel (val) {
      if (val) this.dateMain = val
    },
    item (val) {
      this.onSuccess({
        id: this.itemAction.nameid,
        data: val,
        fieldMain: this.itemAction
      })
    }
  },
  created () {
    if (this.itemAction.cantidad) {
      this.ComboYear(this.itemAction.cantidad)
    } else {
      this.ComboYear(5)
    }
    if (this.itemAction.default) this.Setdefault()
  },
  methods: {
    ComboYear (cantidad) {
      var n = (new Date()).getFullYear()
      const oldyear = n - cantidad
      this.items = []
      for (var i = n; i >= oldyear; i--) this.items.push(i)
      this.setModel(this.setterModel)
    },
    setModel (val) {
      if (val) this.item = val
    },
    Setdefault () {
      var n = (new Date()).getFullYear()
      this.setModel(n)
    }
  }
}
</script>
<style>
</style>
